import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { OrganizationGroup } from './OrganizationGroup'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    active: {
        color: '#4caf50'
    },
    notActive: {
        color: '#f44336'
    },
    groupRow: {
        cursor: 'pointer',
        backgroundColor: theme.palette.grey[50],
        '&:hover': {
            backgroundColor: theme.palette.grey[100]
        }
    },
    nestedCell: {
        paddingLeft: theme.spacing.unit * 4
    },
    expandCell: {
        display: 'flex',
        alignItems: 'center'
    }
})

class OrganizationsTable extends React.Component {
    state = {
        openId: null
    }

    handleUpdate = organization => {
        this.props.onUpdate(organization)
    }

    handleOpenDialog = openId => {
        this.setState({ openId })
    }

    handleCloseDialog = () => {
        this.setState({ openId: null })
    }

    getGroups = () => {
        const { organizations = [] } = this.props
        const groups = {}

        organizations.forEach(org => {
            if (!groups[org.ourId]) {
                groups[org.ourId] = []
            }
            groups[org.ourId].push(org)
        })

        return groups
    }

    render() {
        const { classes, onDelete = [] } = this.props
        const { openId } = this.state

        const groups = this.getGroups()
        const groupKeys = Object.keys(groups)

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID організації EasyMS</TableCell>
                            <TableCell>Назва організації EasyMS</TableCell>
                            <TableCell>ID організації Booking.com</TableCell>
                            <TableCell>Назва організації Booking.com</TableCell>
                            {/*<TableCell>Активна?</TableCell>*/}
                            <TableCell padding="checkbox" />
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groupKeys.map(ourId => (
                            <OrganizationGroup
                                key={ourId}
                                ourId={ourId}
                                items={groups[ourId]}
                                classes={classes}
                                openId={openId}
                                onOpenDialog={this.handleOpenDialog}
                                onCloseDialog={this.handleCloseDialog}
                                onUpdate={this.handleUpdate}
                                onDelete={onDelete}
                            />
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

OrganizationsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    organizations: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired
}

export default withStyles(styles)(OrganizationsTable)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationsTable.js